import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import SideMenu from "./../../../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../../../components/basicComponent/MuiInput";
import MuiButton from "./../../../components/basicComponent/MuiButton";
import Header from "./../../../sharedScreens/Header";
import UserListFilter from "../../../components/composite/UserListFilter";
import { UtilService } from "../../../services/shared/UtilService";
import { OTPAction } from "../../../constants/enum";
import InputLabel from "@mui/material/InputLabel";
import { TopupSchema } from "../../../validations/Schema";
import { MuiDropDown } from "../../../components/basicComponent/MuiDropDown";
import {
  PaymentMode,
  PaymentStatusOptions,
  TopupType,
} from "../../../constants/constant";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { Box, TextField } from "@mui/material";
import { msgTypes } from "../../../constants/msgTypes";
import {
  capitalizeFirstLetter,
  generateRandomInteger,
  getBrowserName,
  removeUnderscores,
} from "../../../constants/helper";
import { useGlobalState } from "../../../services/context/AuthContext";
import TabPanel from "../../../components/basicComponent/TabPanel";
import NoDataFlightCard from "../../../components/composite/NoDataFlightCard";
import MuiSearchSelect from "../../../components/basicComponent/MuiSearchSelect";
import ConfirmationModal from "../../../components/basicComponent/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import { useSweetAlert } from "../../../services/customHooks/useSweetAlert";
import ActivityIndicator from "../../../components/basicComponent/ActivityIndicator";

const RESEND_COOLDOWN = 60; // 1 minute cooldown

const FilterPopUp = ({
  onVerify,
  onClose,
  onResend,
  id,
}: {
  onVerify: (value: any) => void;
  onClose: () => void;
  onResend?: () => void;
  id: any;
}) => {
  const { userInfo } = useGlobalState();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const [timer, setTimer] = useState(RESEND_COOLDOWN);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setError(null); // reset error on change
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleResend = () => {
    if (timer === 0) {
      onResend?.();
      setOtp(new Array(6).fill(""));
      setError(null);
      setTimer(RESEND_COOLDOWN);
    }
  };

  const handleVerify = async () => {
    if (otp.some((digit) => digit === "")) {
      setError("Please enter all 6 digits of the OTP.");
      return;
    } else {
      const payload = {
        action: OTPAction.VERIFY_USER_OTP,
        otp_code: otp.join(""),
      };
      try {
        setError(null);
        const response = await UtilService.verifyUserOtp(id, payload);
        onVerify(response?.data);
      } catch (error) {
        setError("Incorrect OTP. Please try again.");
      }
    }
  };

  return (
    <div className="card-body p-0 pb-n3">
      <InputLabel>Verify OTP Sent to {`${userInfo?.email}`}</InputLabel>
      <Box display="flex" gap={0.5} mt={1}>
        {otp.map((digit, index) => (
          <TextField
            key={index}
            inputRef={(el) => (inputRefs.current[index] = el!)}
            value={digit}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            variant="outlined"
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: "20px",
                width: "20px",
                height: "20px",
              },
            }}
          />
        ))}
      </Box>

      {error && (
        <p style={{ color: "red", marginTop: "8px", fontSize: "14px" }}>
          {error}
        </p>
      )}

      <div className="my-2">
        <button
          className={`text-sm underline ${
            timer === 0
              ? "text-primary text-decoration-underline"
              : "text-blue-500"
          }`}
          onClick={handleResend}
          disabled={timer > 0}
          style={{ background: "none", border: "none" }}
        >
          {timer > 0 ? `Resend OTP in ${timer}s` : "Resend OTP"}
        </button>
      </div>
      <div className="text-sm ms-1 text-muted">
        <strong>Note:</strong> This OTP is valid for 10 minutes
      </div>
      <div className="user-button mt-4">
        <MuiButton
          className="clear-btn"
          label="Cancel"
          type="submit"
          style={{ width: "38%" }}
          onClick={onClose}
        />
        <MuiButton
          className="get-btn"
          label="Submit"
          type="submit"
          style={{ width: "36%" }}
          onClick={handleVerify}
        />
      </div>
    </div>
  );
};
const ITEMS_PER_PAGE = 10;
const TopUpRequestByCorporate: React.FC = () => {
  const { showSuccess, showError, showWarning, showInfo } = useSweetAlert();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(ITEMS_PER_PAGE);
  const { userInfo } = useGlobalState();
  const [selectedStatus, setSelectedStatus] = useState<string>("");

  const [open, setOpen] = useState<boolean>(false);
  const [id, setId] = useState("");
  const [amt, setAmt] = useState<string>("");
  const [isShowConfirmationPopup, setIsShowConfirmationPopup] =
    useState<boolean>(false);
  const [
    isShowNewRequestConfirmationPopup,
    setIsShowNewRequestConfirmationPopup,
  ] = useState<boolean>(false);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  }>({ key: "", direction: "asc" });

  const [paymentReferenceDisbale, setPaymentReferenceDisable] =
    useState<boolean>(false);

  const initialValues = {
    reference_id: "",
    amount: "",
    topup_type: "",
    payment_mode: "",
    payment_reference: "",
    remark: "",
    user_note: [{ corporateNote: "" }, { userNote: "" }],
    requested_by: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: TopupSchema,
    enableReinitialize: true,
    onSubmit: async () => {
      const response = await checkAdminReviewRequest();
      if (response?.data?.length > 0) {
        const amount = response?.data?.[0]?.amount;
        showInfo(
          "",
          `There is a pending request for admin review with amount: ${amount}.
           Please wait for admin approval before creating a new request.`
        );
        formik.resetForm();
      } else {
        const { id, amount } = await checkPendingOtpRequest();
        setAmt(amount);
        if (!!id) {
          setId(id);
          setIsShowConfirmationPopup(true);
        } else {
          setIsShowNewRequestConfirmationPopup(true);
        }
      }
    },
  });

  const getSortedAndPagedData = () => {
    let sorted = [...list];

    if (sortConfig.key) {
      sorted.sort((a: any, b: any) => {
        const aVal = new Date(a[sortConfig.key]).getTime();
        const bVal = new Date(b[sortConfig.key]).getTime();
        return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
      });
    }

    return sorted.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  };

  const handleOtpVerify = async (data: any) => {
    // Assuming success if no error thrown
    if (!!data) {
      formik.resetForm();
      setOpen(false);
      getListOfTopupRequest();
      showSuccess(
        "Success!",
        "Your Topup Request has been created successfully with Amount: " +
          formik.values.amount,
        { timer: 3000, timerProgressBar: true }
      );
    }
  };

  const checkPendingOtpRequest = async () => {
    const params = {
      status: "otp_pending",
    };
    const response = await UtilService.getTopupRequestList(params);
    const isStatusOtpPending = response?.data?.length > 0;
    const id = isStatusOtpPending && response?.data?.[0]?.id;
    const amount = response?.data?.[0]?.amount;
    return { id, amount };
  };
  const checkAdminReviewRequest = async () => {
    const params = {
      status: "admin_review",
    };
    const response = await UtilService.getTopupRequestList(params);

    return response;
  };

  const rejectPendingOtpRequest = async (id: string) => {
    try {
      const payload = {
        action: OTPAction.REJECT_BY_USER,
      };
      await UtilService.verifyUserOtp(id, payload);
      formik.resetForm();
      setOpen(false);
    } catch (error) {
      console.error("Error verifying OTP", error);
    }
  };

  const handleSubmit = async () => {
    const payload = {
      reference_id: "TXN_" + generateRandomInteger(), //TODO: REFACTOR THIS
      amount: formik.values.amount,
      topup_type: formik.values.topup_type,
      payment_mode: formik.values.payment_mode,
      payment_reference: formik.values.payment_reference,
      user_note: formik.values.user_note,
      requested_by: getBrowserName(),
    };
    const response = await UtilService.createTopUpRequest(payload);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      setId(response?.data.id);
    }
    formik.setFieldValue("otpRequired", true);
    setOpen(true);
  };

  const resendOtp = async (id: string) => {
    const payload = {
      action: OTPAction.RESEND_USER_OTP,
    };
    const res = await UtilService.resendUserOtp(id, payload);

    return res;
  };

  const editTopupRequest = async () => {
    const payload = {
      reference_id: formik.values.reference_id,
      amount: formik.values.amount,
      topup_type: formik.values.topup_type,
      payment_mode: formik.values.payment_mode,
      payment_reference: formik.values.payment_reference,
      user_note: formik.values.user_note,
    };
    try {
      const response = await UtilService.editTopupRequestByCorporate(
        payload,
        id
      );
      if (!!response?.data) {
        // setId(response?.data.id);
        sendOtp();
      }
      setOpen(true);
    } catch (error) {}
  };
  useEffect(() => {
    getListOfTopupRequest();
  }, []);
  const getListOfTopupRequest = async (selectedStatus?: string) => {
    setLoading(true);
    const params = {
      status: selectedStatus,
    };
    const response = await UtilService.getTopupRequestList(params);
    if (response?.statusMsg === msgTypes.SUCCESS.msg) {
      setLoading(false);
      setList(response.data);
    } else {
      setLoading(false);
    }
  };
  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  // Calculate the data for the current page
  const currentData = getSortedAndPagedData();
  const handleSort = (key: string) => {
    setSortConfig((prev) => {
      const direction =
        prev.key === key && prev.direction === "asc" ? "desc" : "asc";
      return { key, direction };
    });
  };
  const sendOtp = async () => {
    const payload = {
      action: OTPAction.CORPORATE_APPROVE,
    };
    setPaymentReferenceDisable(false);
    try {
      const response = await UtilService.resendUserOtp(id, payload);
      // if (!!response?.data) {
      //   setIsShowConfirmationPopup(true);
      // }
    } catch (error) {}
  };

  const ViewRequest = () => {
    const RenderTable = () => (
      <div className="row">
        <div className="card card-grid min-w-full">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered  table-hover align-middle">
                <thead className="table-dark">
                  <tr>
                    <th>Reference ID</th>
                    <th>User</th>
                    <th>Amount</th>
                    <th>Top-up Type</th>
                    <th>Payment Mode</th>
                    <th>Requested By</th>
                    <th>Remark</th>
                    <th>Opening Balance</th>
                    <th>Closing Balance</th>
                    <th
                      onClick={() => handleSort("createdAt")}
                      style={{ cursor: "pointer" }}
                    >
                      Created At
                      {sortConfig.key === "createdAt" &&
                        (sortConfig.direction === "asc" ? "↑" : "↓")}
                    </th>
                    <th
                      onClick={() => handleSort("updatedAt")}
                      style={{ cursor: "pointer" }}
                    >
                      Updated At
                      {sortConfig.key === "updatedAt" &&
                        (sortConfig.direction === "asc" ? "↑" : "↓")}
                    </th>

                    <th>Status</th>
                    {<th>Action</th>}
                  </tr>
                </thead>

                {/* Sample row */}
                <tbody className="text-capitalize">
                  {currentData?.length > 0 ? (
                    currentData?.map((item: any, index) => (
                      <tr key={item.id} className="text-color">
                        <td>{item.referenceId}</td>
                        <td>{item.businessName}</td>
                        <td>{item.amount}</td>
                        <td>{item.topupType}</td>
                        <td>{item.paymentMode}</td>
                        <td>{item.requestedByName || ""}</td>
                        <td style={{ whiteSpace: "wrap", minWidth: "596px" }}>
                          {(item.userNote?.[0]?.userNote ||
                            item.userNote?.[1]?.userNote) && (
                            <span>
                              <span className="fw-bold px-1">User Note:</span>
                              {` ${
                                item.userNote?.[0]?.userNote ??
                                item.userNote?.[1]?.userNote ??
                                ""
                              }`}
                            </span>
                          )}
                          {(item.userNote?.[1]?.corporateNote ||
                            item.userNote?.[0]?.corporateNote) && (
                            <span>
                              <span className="fw-bold px-1">
                                Corporate Note:
                              </span>
                              {`${
                                item.userNote?.[1]?.corporateNote ??
                                item.userNote?.[0]?.corporateNote ??
                                ""
                              }`}
                            </span>
                          )}
                          {!!item.adminNote && (
                            <span>
                              <span className="fw-bold px-1">Admin Note:</span>
                              {` ${item.adminNote ?? ""}`}
                            </span>
                          )}
                        </td>
                        <td>{item.openingBalance}</td>
                        <td>{item.closingBalance}</td>
                        <td>{new Date(item.createdAt).toLocaleString()}</td>
                        <td>{new Date(item.updatedAt).toLocaleString()}</td>
                        <td
                          style={{
                            color:
                              item.status === "approved"
                                ? "green"
                                : item.status === "pending"
                                ? "orange"
                                : item.status === "rejected"
                                ? "#e33a3acc"
                                : "#64638e",
                            fontWeight: "bold",
                          }}
                        >
                          {removeUnderscores(
                            item.status === "otp_pending"
                              ? "OTP Pending"
                              : item.status === "admin_otp_pending"
                              ? "Admin OTP Pending"
                              : capitalizeFirstLetter(item.status)
                          )}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center">
                            {item.status === "otp_pending" && (
                              <button
                                type="button"
                                className="btn btn-sm btn-primary "
                                onClick={() => {
                                  setId(item.id);
                                  resendOtp(item?.id ?? "");
                                  setOpen(true);
                                }}
                              >
                                Resend OTP
                              </button>
                            )}
                            {item.status === "pending" && (
                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                  setPaymentReferenceDisable(true);
                                  formik.setFieldValue("amount", item.amount);
                                  formik.setFieldValue(
                                    "reference_id",
                                    item.referenceId
                                  );
                                  formik.setFieldValue(
                                    "user_note[1].userNote",
                                    item.userNote?.[0]?.userNote
                                  );
                                  setId(item.id);

                                  // 🔽 Add your extra logic here
                                  // For example: scroll to top
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                }}
                              >
                                Edit
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <NoDataFlightCard
                          headingText="No Commission Data Found"
                          icon={
                            <SearchOffIcon
                              fontSize="large"
                              className="text-gray-500"
                            />
                          }
                          paragraph=""
                        />
                      </td>
                    </tr>
                  )}
                </tbody>

                {/* Add more rows dynamically */}
              </table>
            </div>
          </div>
          <div className="card-footer justify-center md:justify-between flex-col md:flex-row gap-5 text-gray-600 text-2sm font-medium">
            <div className="pagination">
              <button
                className="btn "
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <i className="ki-outline ki-black-left rtl:transform rtl:rotate-180"></i>
              </button>
              <button className="btn active disabled">{currentPage}</button>
              <button
                className="btn "
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage * itemsPerPage >= list.length}
              >
                <i className="ki-outline ki-black-right rtl:transform rtl:rotate-180"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <>
        {/* <Box sx={{ width: "100%" }}>
          <Tabs value={value} onChange={handleChange} centered>
            {statusTabs.map((tab, index) => (
              <Tab key={index} label={tab.label} id={`tab-${index}`} />
            ))}
          </Tabs>

          {statusTabs.map((_, index) => (
            <TabPanel key={index} value={value} index={index}>
              {renderTable()}
            </TabPanel>
          ))}
        </Box> */}
        {/* <div className="row">
          <div className="col-md-4 mt-2">
            <MuiDropDown
              label="Status"
              placeholder={"Status"}
              options={statusTabs}
              onChange={(val: any) => setSelectedStatus(val)}
              value={selectedStatus}
            />
          </div>
          <div className="col-md-4">
            <div className="user-button mt-3">
              <MuiButton className="clear-btn" label="Cancel" type="reset" />
              <MuiButton
                className="main-btn get-btn"
                variant="contained"
                size="large"
                type="submit"
                label="Get"
                onClick={() => getListOfTopupRequest()}

                />
            </div>
          </div>
        </div> */}
        <div className="card-header mt-4">
          <div className="d-flex flex-wrap">
            <div
              className="user-manage-model w-full"
              style={{ width: "270px" }}
            >
              <MuiDropDown
                label="Status"
                placeholder={"Status"}
                options={PaymentStatusOptions}
                onChange={(val: any) => setSelectedStatus(val)}
                value={selectedStatus}
              />
            </div>

            <div className="ms-3 mt-1 ">
              <button
                className="btn btn-success btn-sm py-1"
                onClick={() => {
                  if (selectedStatus && selectedStatus.trim() !== "") {
                    getListOfTopupRequest(selectedStatus);
                  } else {
                    showInfo("", "Please select status before submitting.");
                  }
                }}
              >
                <i className="ki-filled ki-setting-4"></i>
                Submit
              </button>
            </div>
            <div className="ms-3 mt-1 ">
              <button
                className="btn btn-primary btn-sm py-1"
                onClick={() => {
                  if (selectedStatus) {
                    getListOfTopupRequest(); // No status filter, fetch all
                    setSelectedStatus(""); // Clear selected status
                  } else {
                    showInfo("", "Nothing to clear");
                  }
                }}
              >
                <i className="ki-filled ki-setting-4"></i>
                clear
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center py-4">
            <ActivityIndicator />
          </div>
        ) : list?.length > 0 ? (
          <RenderTable />
        ) : (
          <div className="row justify-content-center mt-5 ">
            <div className="col-md-5">
              <div className="">
                <div className="flex justify-center items-center bg-gray-50 mt-3">
                  <div className="flex items-center justify-center w-16 h-16 bg-blue-50 rounded-full">
                    <img
                      src="media/images/remove-folder.png"
                      alt="remove-folder"
                    />
                  </div>
                </div>

                <div className="no-flights-message p-2 text-center">
                  <h3 className="no-data-head">
                    No data found matching your filters
                  </h3>
                  <p className="text-secondary text-sm">
                    Try adjusting your filter criteria to see more results
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const handleConfirmBtn = async () => {
    const res = await resendOtp(id);
    setOpen(true); // show OTP modal for existing
    setIsShowConfirmationPopup(false);
  };

  const handleCancelBtn = async () => {
    await rejectPendingOtpRequest(id);
    setIsShowConfirmationPopup(false);
    handleSubmit();
  };
  const handleNewRequestConfirmBtn = () => {
    handleSubmit(); // normal case
    setIsShowNewRequestConfirmationPopup(false);
  };
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            {/* <div className="card-header text-center">
              <h3 className="card-title">Topup Request</h3>
            </div> */}
            <div className="card-header mb-1 managebookingg">
              <h3 className="card-title titlecolorr">Topup Request</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <>
                      <div className="row mt-4">
                        <div className="col-md-4 mb-4 mb-md-0 mb-md-0">
                          <MuiInput
                            ref={inputRef}
                            label="Amount"
                            placeholder="Amount"
                            value={formik.values.amount}
                            onChange={(e) => formik.setFieldValue("amount", e)}
                            onBlur={() =>
                              formik.setFieldTouched("amount", true)
                            }
                            isInvalid={
                              formik.touched.amount &&
                              Boolean(formik.errors.amount)
                            }
                            errorText={
                              formik.touched.amount && formik.errors.amount
                                ? formik.errors.amount
                                : ""
                            }
                            type="number"
                          />
                        </div>
                        <div className="col-md-4 mb-4 mb-md-0 mb-md-0">
                          <MuiDropDown
                            label="Topup Type"
                            placeholder="Topup Type"
                            options={TopupType}
                            onChange={(val) =>
                              formik.setFieldValue("topup_type", val)
                            }
                            value={formik.values.topup_type}
                            isRequired={true}
                            errorText={
                              formik.touched.topup_type &&
                              formik.errors.topup_type
                                ? formik.errors.topup_type
                                : ""
                            }
                            isInvalid={
                              formik.touched.topup_type &&
                              Boolean(formik.errors.topup_type)
                            }
                          />
                        </div>
                        <div className="col-md-4">
                          <MuiDropDown
                            label="Payment Mode"
                            placeholder="Payment Mode"
                            options={PaymentMode}
                            onChange={(val) =>
                              formik.setFieldValue("payment_mode", val)
                            }
                            value={formik.values.payment_mode}
                            isRequired={true}
                            errorText={
                              formik.touched.payment_mode &&
                              formik.errors.payment_mode
                                ? formik.errors.payment_mode
                                : ""
                            }
                            isInvalid={
                              formik.touched.payment_mode &&
                              Boolean(formik.errors.payment_mode)
                            }
                          />
                        </div>
                        <div className="col-md-4 mt-4">
                          <MuiInput
                            label="Payment Reference"
                            placeholder="Payment Reference"
                            onChange={(val) =>
                              formik.setFieldValue("payment_reference", val)
                            }
                            onBlur={() =>
                              formik.setFieldTouched("payment_reference", true)
                            }
                            value={formik.values.payment_reference}
                            isRequired={true}
                            isInvalid={
                              formik.touched.payment_reference &&
                              Boolean(formik.errors.payment_reference)
                            }
                            errorText={
                              formik.touched.payment_reference &&
                              formik.errors.payment_reference
                                ? formik.errors.payment_reference
                                : ""
                            }
                          />
                        </div>

                        <div className="col-md-4 mt-4">
                          <MuiInput
                            label="Remark"
                            placeholder="Remark"
                            value={formik.values.remark}
                            onChange={(val) => {
                              formik.setFieldValue("remark", val);
                              formik.setFieldValue(
                                "user_note[0].corporateNote",
                                val
                              );
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("remark", true)
                            }
                            isInvalid={
                              formik.touched.remark &&
                              Boolean(formik.errors.remark)
                            }
                            errorText={
                              formik.touched.remark && formik.errors.remark
                                ? formik.errors.remark
                                : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="user-button mt-4">
                        <MuiButton
                          className="clear-btn"
                          label={"Clear"}
                          type="reset"
                          onClick={() => {
                            formik.resetForm();
                            setPaymentReferenceDisable(false);
                          }}
                        />
                        <MuiButton
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                          label="Submit"
                          onClick={() =>
                            paymentReferenceDisbale
                              ? editTopupRequest()
                              : formik.handleSubmit()
                          }
                        />
                      </div>

                      <ViewRequest />
                      <UserListFilter
                        header={"Verify OTP"}
                        children={
                          <FilterPopUp
                            onVerify={handleOtpVerify}
                            onClose={() => {
                              setOpen(false);
                              formik.resetForm();
                              getListOfTopupRequest();
                            }}
                            onResend={() => {
                              resendOtp(id);
                            }}
                            id={id}
                          />
                        }
                        isVisible={open}
                        handleClose={() => setOpen(false)}
                      />

                      <ConfirmationModal
                        handleClose={() => {
                          handleCancelBtn();
                        }}
                        header={`You already have a pending OTP request with amount ${amt}. Do you want to continue with it?`}
                        isVisible={isShowConfirmationPopup}
                        onConfirm={() => {
                          handleConfirmBtn();
                        }}
                        buttonText="Ok"
                      />
                      <ConfirmationModal
                        handleClose={() => {
                          setIsShowNewRequestConfirmationPopup(false);
                        }}
                        header={"Do you want to continue with this request?"}
                        isVisible={isShowNewRequestConfirmationPopup}
                        onConfirm={() => {
                          handleNewRequestConfirmBtn();
                        }}
                        buttonText="Ok"
                      />
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default TopUpRequestByCorporate;
